import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum'
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage'

export const getSessionIdFromLocalStorage = (): string | undefined => {
  return getDataFromLocalStorage<string>(LocalStorageKey.SESSION_ID)
}
